export const GET_TRANSFER_LOG_TABLE = "GET_TRANSFER_LOG_TABLE";
export const SET_TRANSFER_LOG_PAGE_DATA = "SET_TRANSFER_LOG_PAGE_DATA";
export const SET_TRANSFER_LOG_FILTERS = "SET_TRANSFER_LOG_FILTERS";
export const SET_TRANSFER_LOG_PAGE = "SET_TRANSFER_LOG_PAGE";
export const SET_TRANSFER_LOG_SIZE = "SET_TRANSFER_LOG_SIZE";
export const PREPEND_TRANSFER_LOG_ITEMS = "PREPEND_TRANSFER_LOG_ITEMS";
export const ACKNOWLEDGE_NEW_ENTRIES = "ACKNOWLEDGE_NEW_ENTRIES";
